<div fxFlex fxLayout="column">
  <sidenav fxFlex fxLayout="column">
    <header-home __fxLayout="column"></header-home>
    <router-outlet></router-outlet>
    <footer-home fxLayout="column"></footer-home>
  </sidenav>
</div>
